import React from "react";
import classNames from "classnames";
import SelectField from '../../SelectField/SelectField';
import styles from '../DateField.module.scss';

const DateFieldYearMonthForm = ({
  fromMonth,
  toMonth,
  date,
  localeUtils,
  onChange,
}: any) => {
  const months = localeUtils.getMonths();
  const dateMonth = date.getMonth();
  const dateFullYear = date.getFullYear();
  const years = [];

  for (let i = fromMonth.getFullYear(); i <= toMonth.getFullYear(); i += 1) {
    years.push(i);
  }

  const handleChangeYear = (value: string) => {
    onChange(new Date(parseInt(value), dateMonth));
  };

  const handleChangeMonth = (value: string) => {
    onChange(new Date(dateFullYear, parseInt(value)));
  };

  return (
    <div className={classNames('DayPicker-Caption', styles.caption)}>
      <div className={styles.captionBody}>
        <SelectField
          id="month"
          name="month"
          className={styles.captionElement}
          selectedFieldClassname={styles.captionSelected}
          fieldListClassname={styles.captionSelectList}
          value={dateMonth.toString()}
          options={months.map((month: string, i: number) => ({
            name: month,
            value: i.toString(),
          }))}
          onChange={handleChangeMonth}
        />

        <SelectField
          id="year"
          name="year"
          className={styles.captionElement}
          selectedFieldClassname={styles.captionSelected}
          fieldListClassname={styles.captionSelectList}
          value={dateFullYear}
          options={years.reverse().map((year) => ({
            name: year,
            value: year,
          }))}
          onChange={handleChangeYear}
        />
      </div>
    </div>
  );
}

export default DateFieldYearMonthForm;
